export default __webpack_public_path__ + "static/media/insta08.5b4ed42c.webp";